<template>
  <div class="ap-page">

    <!-- Bulk publish progress -->
    <div v-if="dk_run_items.length" class="ap-card ap-run">
      <div class="ap-card__head">
        <div class="ap-card__title-wrap">
          <span class="ap-card__icon ap-card__icon--warn"><CIcon name="iconList"/></span>
          <div>
            <h2 class="ap-card__title">انتشار گروهی از دیجی‌کالا</h2>
            <p class="ap-card__sub">
              {{ dk_run_items.filter(x => x.state === 'ok' || x.state === 'error' || x.state === 'skip').length }} از {{ dk_run_items.length }} انجام شد ·
              {{ dk_run_items.filter(x => x.state === 'ok').length }} موفق ·
              {{ dk_run_items.filter(x => x.state === 'skip').length }} تکراری
            </p>
          </div>
        </div>
        <div class="ap-toolbar">
          <button type="button" class="ap-btn ap-btn--danger" v-if="dk_bulk_running" @click="dk_bulk_stop = true">توقف</button>
          <button type="button" class="ap-btn ap-btn--ghost" v-if="!dk_bulk_running" @click="$router.push('/dashboard/products/digikala-bulk')">صفحهٔ نتایج</button>
          <button type="button" class="ap-btn ap-btn--ghost" v-if="!dk_bulk_running" @click="dk_run_items = []">بستن</button>
        </div>
      </div>
      <div class="ap-card__body">
        <div class="ap-muted mb-2" v-if="dk_bulk_status">{{ dk_bulk_status }}</div>
        <div class="ap-run__list">
          <div v-for="(it, i) in dk_run_items" :key="'dkr' + it.dk_id" class="ap-run__row" :class="'is-' + it.state">
            <span class="ap-run__num">{{ i + 1 }}</span>
            <span class="ap-run__state">
              <CSpinner v-if="it.state === 'working'" size="sm" color="primary"/>
              <span v-else-if="it.state === 'ok'" class="ap-run__ok">✓</span>
              <span v-else-if="it.state === 'error'" class="ap-run__err">✗</span>
              <span v-else-if="it.state === 'skip'" class="ap-run__skip" title="تکراری">↷</span>
              <span v-else class="ap-run__wait">•</span>
            </span>
            <span class="ap-run__title">
              {{ it.title }}
              <small class="ap-run__err d-block" v-if="it.error">{{ it.error }}</small>
              <small class="ap-muted d-block" v-if="it.state === 'skip'">این محصول قبلاً در سایت ثبت شده؛ رد شد</small>
            </span>
            <a v-if="it.site_link" :href="it.site_link" target="_blank" dir="ltr" class="ap-run__link">{{ decodeURI(it.site_link) }}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Page header -->
    <div class="ap-card ap-header">
      <div class="ap-card__head">
        <div class="ap-card__title-wrap">
          <span class="ap-card__icon"><CIcon name="navProducts"/></span>
          <div>
            <h1 class="ap-card__title ap-card__title--lg">{{ status_form == 0 ? 'ثبت محصول' : 'ویرایش محصول' }}</h1>
            <p class="ap-card__sub">اطلاعات، قیمت، دسته‌بندی و تصاویر محصول را وارد کنید</p>
          </div>
        </div>
        <div class="ap-toolbar">
          <button type="button" class="ap-btn ap-btn--ghost" @click="digikala_modal=true">
            <CIcon name="iconDownload"/><span>افزودن از سایت دیگر</span>
          </button>
          <button type="button" class="ap-btn ap-btn--ghost" @click="dk_bulk_modal=true">
            <CIcon name="iconList"/><span>افزودن گروهی از دیجی‌کالا</span>
          </button>
          <button type="button" class="ap-icon-btn" title="مشاهده در سایت" @click="go_to_product()">
            <CIcon name="navEye"/>
          </button>
          <button type="button" class="ap-icon-btn" title="کپی لینک محصول" @click="copy_product_link()">
            <CIcon name="iconClone"/>
          </button>
          <button type="button" class="ap-btn ap-btn--primary" ref="submit_form" @click="login()">
            <CIcon name="iconCheck"/><span>{{ status_form == 0 ? 'افزودن محصول' : 'بروزرسانی' }}</span>
          </button>
        </div>
      </div>
    </div>

    <CRow class="ap-grid">
      <!-- Main column -->
      <CCol col="12" lg="8">

        <section class="ap-card">
          <div class="ap-section__head"><h3>اطلاعات اصلی</h3></div>
          <div class="ap-card__body">
            <CRow>
              <CCol col="12" md="8">
                <CInput v-model="title" class="required" label="عنوان محصول" placeholder="عنوان"/>
              </CCol>
              <CCol col="12" md="4">
                <CInput v-model="code" class="required" label="کد محصول" placeholder="کد"/>
              </CCol>
              <CCol col="12" md="6">
                <CSelect
                    :options="[{label:'محصول فیزیکی',value:1},{label:'محصول دانلودی',value:2}]"
                    :value.sync="product_type"
                    label="نوع محصول"
                />
              </CCol>
              <CCol col="12" md="6">
                <CInput label="آدرس جایگزین (اسلاگ)" v-model="favorite_url" dir="ltr"/>
              </CCol>
            </CRow>
          </div>
        </section>

        <section class="ap-card">
          <div class="ap-section__head"><h3>توضیحات</h3></div>
          <div class="ap-card__body">
            <div class="ap-field-label">توضیحات کوتاه</div>
            <div class="ap-editor">
              <editorjs v-if="loaded_page"
                        editor_id="add_new_editor"
                        key="add_new_editor"
                        :first_content.sync="content_json"
                        :content_json.sync="content_json"
                        :content_text.sync="content_text"
                        :content_html.sync="content_html"
              />
            </div>
            <div class="ap-field-label mt-4">توضیحات کامل</div>
            <div class="ap-editor">
              <editorjs v-if="loaded_page"
                        editor_id="add_new_editor_full"
                        key="add_new_editor_full"
                        :first_content.sync="content_json_full"
                        :content_json.sync="content_json_full"
                        :content_text.sync="content_text_full"
                        :content_html.sync="content_html_full"
              />
            </div>
          </div>
        </section>

        <SeoBox ref="seo" class="ap-seobox"
                entity-type="product"
                :entity-id="dk_bulk_mode ? 0 : status_form"
                :name="title"
                :slug="favorite_url"
                url-prefix="/product/"
                :content-html="(content_html || '') + (content_html_full || '')"
                :title.sync="seo_title"
                :description.sync="seo_summary"
                :keyword.sync="keyword"
                :default-sku="code"
                default-schema="Product"
        />

        <section class="ap-card">
          <div class="ap-section__head"><h3>الگو ویژگی</h3></div>
          <div class="ap-card__body">
            <CRow>
              <CCol col="12" md="6">
                <CSelect label="الگو ویژگی" :options="property_items" :value.sync="selected_property"/>
              </CCol>
            </CRow>
            <CDataTableFixed
                v-if="property_group_items.length"
                class="ap-props"
                :items="property_group_items"
                :fields="fields_properties"
                :items-per-page="20"
                hover
            >
              <template #group="{item}">
                <td><p class="ap-muted mb-0">{{ item.name }}</p></td>
              </template>
              <template #property="{item}">
                <CDataTableFixed :items="item.items" :fields="fields_properties_items" hover>
                  <template #title="{item}">
                    <td><p style="min-width: 100px" class="ap-muted mb-0">{{ item.name }}</p></td>
                  </template>
                  <template #value="{item}">
                    <td class="ap-props__values">
                      <CInput v-for=" lng in item.lang_values" :key="lng.lng.id"
                              v-model="lng.value"
                              class="mb-0"
                              :placeholder="lng.lng.name"
                      />
                    </td>
                  </template>
                </CDataTableFixed>
              </template>
            </CDataTableFixed>
          </div>
        </section>
      </CCol>

      <!-- Side column -->
      <CCol col="12" lg="4">
        <div class="ap-side">
          <section class="ap-card">
            <div class="ap-section__head"><h3>قیمت و موجودی</h3></div>
            <div class="ap-card__body">
              <CInputCurrency v-model="product_price" class="required" label="قیمت محصول"
                              description="برای گزینه «تماس بگیرید» قیمت را صفر وارد کنید"/>
              <CRow>
                <CCol col="6">
                  <CInputCurrency v-model="product_stock" class="required mb-1" label="موجودی"/>
                </CCol>
                <CCol col="6">
                  <CInput v-model="order_point" label="نقطه سفارش"/>
                </CCol>
              </CRow>
              <p class="ap-hint ap-hint--warn">اگر این محصول متغیر دارد، موجودی باید 0 باشد</p>
              <CSelect label="ارز" :options="currency_items" :value.sync="selected_currency"/>
              <CInputCurrency v-model="product_off_price" label="قیمت ویژه (تخفیف)"/>
              <div class="ap-field-label">محدودیت زمان تخفیف</div>
              <date-picker
                  v-model="product_off_price_date"
                  type="datetime"
                  display-format="jYYYY/jMM/jDD HH:mm"
                  format="YYYY-MM-DD HH:mm"
                  inputFormat="YYYY-MM-DD HH:mm"
              />
              <p class="ap-hint">برای تخفیف همیشگی خالی بگذارید</p>
            </div>
          </section>

          <section class="ap-card">
            <div class="ap-section__head"><h3>دسته‌بندی و برند</h3></div>
            <div class="ap-card__body">
              <div class="ap-field">
                <div class="ap-field-label">دسته‌بندی محصول <span class="text-danger">*</span></div>
                <treeselect
                    v-model="value_category"
                    :class="{'is-invalid': category_touched && (!value_category || !value_category.length)}"
                    :multiple="true"
                    :flat="true"
                    :normalizer="normalizer_category"
                    :options="options_category"
                    placeholder="دسته‌بندی محصول را انتخاب کنید"
                />
                <small v-if="category_touched && (!value_category || !value_category.length)" class="text-danger d-block mt-1">انتخاب دسته‌بندی محصول الزامی است</small>
              </div>
              <div class="ap-field">
                <div class="ap-field-label">برند محصول <span class="text-danger">*</span></div>
                <treeselect
                    v-model="value_brand"
                    :multiple="false"
                    :normalizer="normalizer_brand"
                    :options="options_brand"
                    placeholder="برند محصول را انتخاب کنید"
                />
              </div>
              <div class="ap-field mb-0">
                <div class="ap-field-label">برچسب‌ها</div>
                <treeselect
                    v-model="value_tags"
                    :multiple="true"
                    :async="true"
                    :load-options="load_tags"
                    placeholder="انتخاب برچسب‌ها"
                    :normalizer="normalizer_tags"
                />
              </div>
            </div>
          </section>

          <section class="ap-card">
            <div class="ap-section__head"><h3>گالری تصاویر</h3></div>
            <div class="ap-card__body">
              <ImageSelector label="گالری تصویر"
                             v-if="show_gallery"
                             :media_id.sync="gallery"
                             :multiple="true"
                             default_archive="products"
                             :preview-image="previewImage"
              />
            </div>
          </section>
        </div>
      </CCol>
    </CRow>

    <!-- Sticky save bar -->
    <div class="ap-savebar">
      <span class="ap-muted">{{ title || 'محصول جدید' }}</span>
      <button type="button" class="ap-btn ap-btn--primary" @click="login()">
        <CIcon name="iconCheck"/><span>{{ status_form == 0 ? 'افزودن محصول' : 'بروزرسانی' }}</span>
      </button>
    </div>

    <!-- Import single product from another site -->
    <CModal
        title="افزودن از سایت دیگر"
        :show.sync="digikala_modal"
        :close-on-backdrop="true"
    >
      <CSelect :value.sync="digikala_modal_selected_type" :options="digikala_modal_types" label="سایت مبدا"/>
      <CInput v-model="digikala_link" label="لینک محصول" dir="ltr"/>
      <div class="ap-switch">
        <CSwitch color="success" shape="pill" :checked.sync="digikala_modal_download_image"/>
        <label>دانلود تصاویر</label>
      </div>
      <template #footer>
        <CButton color="secondary" @click="digikala_modal = false">انصراف</CButton>
        <CButton color="primary" @click="digikala_modal = false,get_digikala_data()">دریافت اطلاعات</CButton>
      </template>
    </CModal>

    <!-- Bulk publish from a Digikala search -->
    <CModal
        title="افزودن گروهی از جستجوی دیجی‌کالا"
        size="lg"
        :show.sync="dk_bulk_modal"
        :close-on-backdrop="false"
    >
      <CInput v-model="dk_bulk_url" dir="ltr" label="لینک جستجو یا دسته‌بندی دیجی‌کالا"
              placeholder="لینک جستجو، دسته‌بندی یا برند دیجی‌کالا"/>
      <div class="ap-field">
        <div class="ap-field-label">دسته‌بندی محصولات <span class="text-danger">*</span></div>
        <treeselect
            v-model="value_category"
            :multiple="true"
            :flat="true"
            :normalizer="normalizer_category"
            :options="options_category"
            placeholder="دسته‌بندی را انتخاب کنید"
        />
      </div>
      <CRow>
        <CCol col="12" md="6">
          <div class="ap-field">
            <div class="ap-field-label">برند</div>
            <treeselect
                v-model="value_brand"
                :multiple="false"
                :normalizer="normalizer_brand"
                :options="options_brand"
                placeholder="برند را انتخاب کنید"
            />
          </div>
        </CCol>
        <CCol col="12" md="6">
          <CInputCurrency v-model="product_stock" label="موجودی هر محصول *"/>
        </CCol>
        <CCol col="6">
          <CInput v-model="dk_bulk_max" type="number" label="حداکثر تعداد محصول"/>
        </CCol>
        <CCol col="6">
          <CInput v-model="dk_bulk_delay" type="number" label="فاصله بین هر محصول (ثانیه)"/>
        </CCol>
      </CRow>
      <div class="ap-switch">
        <CSwitch color="success" shape="pill" :checked.sync="dk_bulk_download_image"/>
        <label>دانلود عکس‌ها</label>
      </div>
      <div class="text-danger mb-2" v-if="dk_bulk_form_error">{{ dk_bulk_form_error }}</div>
      <p class="ap-hint mb-0">
        نوع محصول، برچسب‌ها، واحد پول و نقطهٔ سفارش هم از فرم صفحه برای همهٔ محصولات استفاده می‌شود.
        لیست محصولات از طریق npm run serve (پروکسی محلی) خوانده می‌شود.
      </p>
      <template #footer>
        <CButton color="secondary" :disabled="dk_bulk_running" @click="dk_bulk_modal = false">بستن</CButton>
        <CButton color="primary" :disabled="dk_bulk_running" @click="dk_bulk_run_here()">شروع انتشار</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
function dkPrice(product) {
  // Digikala: rrp_price = list price, selling_price = actual price (both in Rial). Either may be missing.
  const v = (product && product.default_variant && product.default_variant.price) || {};
  const rrp = Number(v.rrp_price) || 0;
  const sell = Number(v.selling_price) || 0;
  const base = rrp || sell;
  return { price: base ? Math.round(base / 10) : '', off: sell && rrp && sell < rrp ? Math.round(sell / 10) : '' };
}
import axios from "@/api/http";
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
import VueUploadMultipleImage from 'vue-upload-multiple-image'


import Vue from "vue";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import editorjs from "@/views/includes/editorjs.vue";
// import  Readability from "@/plugins/readability";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}

export default {
  name: 'Login',
  components: {
    editorjs,
    Treeselect,
    VueUploadMultipleImage,
  },
  data() {

    return {
      loaded_page: false,
      content_json: {},
      content_text: '',
      content_html: '',

      content_json_full: {},
      content_text_full: '',
      content_html_full: '',

      previewImage: null,
      gallery: [],
      product_type: 1,
      value_brand: null,
      options_brand: [],
      value_category: [],
      value_tags: [],
      related_products: [],
      selected_property: 0,
      property_items: [],
      language_items: [],
      currency_items: [],
      selected_currency: 0,
      property_group_items: [],
      product_property_values: [],
      fields_properties: [
        {key: 'group', label: 'گروه', _style: 'width:10%'},
        {key: 'property', label: 'ویژگی', _style: 'width:90%'},
      ],
      fields_properties_items: [
        {key: 'title', label: 'عنوان', _style: 'width:20%;display:none'},
        {key: 'value', label: 'مقدار', _style: 'width:80%;display:none'},
      ],
      options_category: [],
      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },
      normalizer_brand(node) {
        return {
          id: node.id,
          label: node.title.title,
        }
      },

      normalizer_tags(node) {
        return {
          id: node.title,
          label: node.title,
        }
      },

      editorConfig: {
        extraPlugins: [],
        language: 'fa'
        // The configuration of the editor.
      },
      title: '',
      code: '',
      favorite_url: '',
      keyword: '',
      seo_title: '',
      summary: '',
      seo_summary: '',
      product_price: '',
      order_point: '0',
      product_stock: '',
      product_off_price: '',
      product_off_price_date: '',
      tags: '',
      digikala_modal: false,
      digikala_modal_types: [{label: 'دیجیکالا', value: 1}, {label: 'وردپرس', value: 2}],
      digikala_modal_selected_type: 1,
      digikala_modal_download_image: true,
      show_gallery: true,
      digikala_link: '',
      dk_bulk_modal: false,
      dk_run_items: [],
      dk_bulk_form_error: '',
      dk_bulk_mode: false,
      dk_import_error: '',
      dk_specs: null,
      dk_meta: null,
      category_touched: false,
      dk_bulk_status: '',
      dk_last_save: null,
      dk_bulk_url: '',
      dk_bulk_max: 5,
      dk_bulk_delay: 3,
      dk_bulk_download_image: true,
      dk_bulk_running: false,
      dk_bulk_stop: false,
      dk_bulk_log: [],
      dk_bulk_done: 0,
      dk_bulk_total: 0,
      status_form: 0,

    }
  },
  mounted() {

    this.get_categories();
    this.get_brands();
    this.get_properties();
    this.get_currencies();
    this.get_languages();

  }, watch: {
    'selected_property': function () {
      this.get_property_groups();
    },
    'seo_summary': function () {
      // console.log("seo changed",Readability.getScore(this.seo_summary))
    }
  },
  methods: {
    // Bulk publish exactly like a user: for each product, fill this form with "افزودن از سایت دیگر" and press save
    dk_norm_name(name) {
      return String(name || '').replace(/[\u200c\s]+/g, ' ').replace(/ي/g, 'ی').replace(/ك/g, 'ک').trim().toLowerCase();
    },
    // Existing products on the site, used to skip duplicates (by code = Digikala id, or by same name)
    async dk_load_existing() {
      const res = await axios.post('/api/admin/product/get_products', new FormData(), {show_pros: false});
      const codes = {}, names = {}, slugs = {};
      ((res.data && res.data.items) || []).forEach((p) => {
        const name = (p.title && p.title.title) || p.name;
        if (p.code !== undefined && p.code !== null && p.code !== '') {
          const code = String(p.code).trim();
          codes[code] = p;
          codes[code.replace(/^dk-/i, '')] = p; // older imports saved the code as "dk-<id>"
        }
        if (name) names[this.dk_norm_name(name)] = p;
        if (p.title && p.title.slug) slugs[p.id] = p.title.slug;
      });
      return {codes, names, slugs};
    },
    async dk_bulk_run_here() {
      this.dk_bulk_form_error = '';
      if (!this.dk_bulk_url) { this.dk_bulk_form_error = 'لینک جستجوی دیجی‌کالا را وارد کنید'; return; }
      if (!this.value_category || !this.value_category.length) { this.dk_bulk_form_error = 'دسته‌بندی را انتخاب کنید'; return; }
      if (this.product_stock === '' || this.product_stock === null || this.product_stock === undefined) { this.dk_bulk_form_error = 'موجودی را وارد کنید'; return; }
      this.dk_bulk_modal = false;
      this.dk_bulk_running = true;
      this.dk_bulk_stop = false;
      this.dk_bulk_mode = true;
      this.dk_run_items = [];
      const quiet = axios.interceptors.request.use((config) => { config.show_pros = false; return config; });
      const keep = {
        product_type: this.product_type, value_category: this.value_category, value_tags: this.value_tags,
        value_brand: this.value_brand, keyword: this.keyword,
        product_stock: this.product_stock, order_point: this.order_point, selected_currency: this.selected_currency,
        selected_property: this.selected_property, product_off_price: this.product_off_price, product_off_price_date: this.product_off_price_date,
      };
      const site = (localStorage.getItem('site_url') || '').replace(/\/+$/, '');
      const delay = Math.max(0, parseFloat(this.dk_bulk_delay) || 0) * 1000;
      try {
        this.dk_bulk_status = 'در حال خواندن لیست محصولات از دیجی‌کالا...';
        const list = await this.dk_bulk_fetch_ids(this.dk_bulk_url, Math.max(1, parseInt(this.dk_bulk_max) || 1));
        this.dk_run_items = list.map((x) => ({dk_id: x.id, title: x.title, state: 'waiting', error: '', product_id: null, site_link: ''}));
        this.dk_bulk_status = 'در حال بررسی محصولات تکراری...';
        let existing = {codes: {}, names: {}, slugs: {}};
        try { existing = await this.dk_load_existing(); } catch (e) { console.log(e); }
        this.dk_bulk_status = '';
        for (let i = 0; i < this.dk_run_items.length; i++) {
          if (this.dk_bulk_stop) break;
          const it = this.dk_run_items[i];
          const dup = existing.codes[String(it.dk_id)] || existing.names[this.dk_norm_name(it.title)];
          if (dup) {
            it.state = 'skip';
            it.product_id = dup.id;
            const slug = existing.slugs[dup.id];
            if (site && slug) it.site_link = site + '/product/' + slug;
            localStorage.setItem('dk_bulk_result', JSON.stringify(this.dk_run_items));
            continue;
          }
          it.state = 'working';
          try {
            Object.assign(this, keep);
            this.title = '';
            this.gallery = [];
            this.dk_specs = null;
            this.dk_meta = null;
            this.dk_last_save = null;
            this.digikala_modal_selected_type = 1;
            this.digikala_modal_download_image = this.dk_bulk_download_image;
            this.digikala_link = 'https://www.digikala.com/product/dkp-' + it.dk_id + '/';
            this.dk_import_error = '';
            this.get_digikala_data();
            // wait until the form is filled (title, then images)
            let waited = 0;
            while (!this.title && !this.dk_import_error && waited < 120000) { await this.dk_bulk_sleep(300); waited += 300; }
            if (!this.title) throw new Error(this.dk_import_error || 'اطلاعات محصول از دیجی‌کالا خوانده نشد');
            await this.dk_bulk_sleep(1500);
            this.code = String(it.dk_id);
            await this.login();
            const res = this.dk_last_save;
            if (res && res.error == 0) {
              it.product_id = res.id;
              try {
                const fd = new FormData();
                fd.append('product_id', res.id);
                const info = await axios.post('/api/admin/product/get_product_info', fd, {show_pros: false});
                if (site && info.data.post.title.slug) it.site_link = site + '/product/' + info.data.post.title.slug;
              } catch (e) {}
              it.state = 'ok';
              existing.codes[String(it.dk_id)] = {id: res.id};
              existing.names[this.dk_norm_name(it.title)] = {id: res.id};
            } else {
              it.state = 'error';
              it.error = res ? ((res.msg || res.message || '') + ' | پاسخ سرور: ' + JSON.stringify(res).slice(0, 400)) : 'ذخیره انجام نشد';
            }
          } catch (e) {
            it.state = 'error';
            it.error = e && e.message ? e.message : String(e);
          }
          this.code = '';
          localStorage.setItem('dk_bulk_result', JSON.stringify(this.dk_run_items));
          if (i < this.dk_run_items.length - 1 && delay && !this.dk_bulk_stop) await this.dk_bulk_sleep(delay);
        }
        this.dk_run_items.forEach((x) => { if (x.state === 'waiting') { x.state = 'error'; x.error = 'انجام نشد (متوقف شد)'; } });
      } catch (e) {
        this.dk_bulk_status = 'خطا: ' + (e && e.message ? e.message : e);
      }
      localStorage.setItem('dk_bulk_result', JSON.stringify(this.dk_run_items));
      localStorage.setItem('dk_bulk_job', JSON.stringify({status: 'done', url: this.dk_bulk_url}));
      axios.interceptors.request.eject(quiet);
      this.dk_bulk_mode = false;
      this.dk_bulk_running = false;
    },
    // Saves the job (link + this form's settings) and opens the dedicated progress page
    dk_bulk_open_page() {
      this.dk_bulk_form_error = '';
      if (!this.dk_bulk_url) { this.dk_bulk_form_error = 'لینک جستجوی دیجی‌کالا را وارد کنید'; this.dk_bulk_add_log('لینک را وارد کنید', false); return; }
      if (!this.value_category || !this.value_category.length) { this.dk_bulk_form_error = 'دسته‌بندی را انتخاب کنید'; return; }
      if (this.product_stock === '' || this.product_stock === null || this.product_stock === undefined) { this.dk_bulk_form_error = 'موجودی را وارد کنید'; return; }
      const job = {
        status: 'new',
        url: this.dk_bulk_url,
        max: this.dk_bulk_max,
        delay: this.dk_bulk_delay,
        download_image: this.dk_bulk_download_image,
        settings: {
          property_group_items: this.property_group_items,
          product_type: this.product_type,
          value_category: this.value_category,
          value_tags: this.value_tags,
          value_brand: this.value_brand,
          keyword: this.keyword,
          product_stock: this.product_stock,
          order_point: this.order_point,
          selected_currency: this.selected_currency,
        },
      };
      localStorage.setItem('dk_bulk_job', JSON.stringify(job));
      this.dk_bulk_modal = false;
      this.$router.push('/dashboard/products/digikala-bulk');
    },
    // ---------- Bulk import from a Digikala search/category URL ----------
    dk_bulk_add_log(text, ok) {
      this.dk_bulk_log.push({text: text, ok: ok});
    },
    dk_bulk_sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    // Turns a www.digikala.com search/category URL into the matching API path (served by the local /dk-api proxy)
    // Supported links (query string filters like sort, brands[0], has_selling_stock are kept):
    //   /search/?q=...                     search
    //   /search/category-heater/           category
    //   /search/category-heater/butane/    category + brand
    //   /brand/butane/                     brand
    //   /product/dkp-123/                  a single product
    dk_bulk_parse_link(link) {
      let txt = String(link || '').trim();
      if (!/^https?:\/\//i.test(txt)) txt = 'https://www.digikala.com/' + txt.replace(/^\/+/, '');
      const u = new URL(txt);
      if (!/digikala\.com$/i.test(u.hostname)) throw new Error('لینک باید از digikala.com باشد');
      const p = decodeURIComponent(u.pathname).replace(/\/+$/, '') + '/';
      const params = new URLSearchParams(u.search);
      let m;
      if ((m = p.match(/\/product\/dkp-(\d+)/))) return {type: 'product', id: parseInt(m[1])};
      if ((m = p.match(/\/search\/category-([^/]+)\/([^/]+)\//))) return {type: 'list', api: '/v1/categories/' + m[1] + '/brands/' + m[2] + '/search/', params};
      if ((m = p.match(/\/(?:search\/)?category-([^/]+)\//))) return {type: 'list', api: '/v1/categories/' + m[1] + '/search/', params};
      if ((m = p.match(/\/brand\/([^/]+)\//))) return {type: 'list', api: '/v1/brands/' + m[1] + '/', params};
      if (/^\/search\/$/.test(p)) return {type: 'list', api: '/v1/search/', params};
      throw new Error('این نوع لینک دیجی‌کالا پشتیبانی نمی‌شود (جستجو، دسته‌بندی، برند یا محصول)');
    },
    // Digikala API through our server (allowlisted proxy): works in production, not only with `npm run serve`
    async dk_api(apiPath, params) {
      const fd = new FormData();
      fd.append('path', apiPath);
      fd.append('query', params ? params.toString() : '');
      const res = await axios.post('/api/admin/product/digikala_api', fd, {show_pros: false});
      if (!res.data || res.data.error === 1) throw new Error((res.data && res.data.msg) || 'خطا در ارتباط با دیجی‌کالا');
      return res.data;
    },
    dk_bulk_api_path(link, page) {
      const info = this.dk_bulk_parse_link(link);
      const params = new URLSearchParams(info.params);
      params.set('page', page);
      return '/dk-api' + info.api + '?' + params.toString();
    },
    async dk_bulk_fetch_ids(link, max) {
      const info = this.dk_bulk_parse_link(link);
      if (info.type === 'product') {
        let title = 'dkp-' + info.id;
        try {
          const j = await this.dk_api('/v2/product/' + info.id + '/');
          title = (j.data && j.data.product && j.data.product.title_fa) || title;
        } catch (e) {}
        return [{id: info.id, title: title}];
      }
      const ids = [];
      let page = 1;
      let total_pages = 1;
      while (ids.length < max && page <= total_pages && !this.dk_bulk_stop) {
        const params = new URLSearchParams(info.params);
        params.set('page', page);
        const json = await this.dk_api(info.api, params);
        const data = json.data || {};
        total_pages = (data.pager && data.pager.total_pages) || 1;
        (data.products || []).forEach((p) => {
          if (ids.length < max && !ids.some((x) => x.id === p.id)) ids.push({id: p.id, title: p.title_fa});
        });
        page++;
      }
      if (!ids.length) throw new Error('در این لینک محصولی پیدا نشد');
      return ids;
    },
    // Same mapping as get_digikala_data(), but returns a FormData for insert_product instead of filling the form
    dk_bulk_build_form(contents, dk_id) {
      const product = contents.data.product;
      const seo = contents.data.seo || {};
      let json_table = [];
      try {
        product.specifications[0].attributes.forEach(function (val) {
          json_table.push([val.title, val.values[0]]);
        });
      } catch (e) {}
      // specs go to dk_specifications/properties only, never into the short description
      const text = {time: Date.now(), blocks: [], version: '2.28.2'};
      const full_text = {time: 1708248359501, blocks: [{id: 'DSM8JadA6h', type: 'paragraph', data: {text: (product.expert_reviews && product.expert_reviews.description) || '', alignment: 'right'}}], version: '2.28.2'};
      let price = '';
      const dkp = dkPrice(product); price = dkp.price;

      const formData = new FormData();
      try {
        product.images.list.forEach(function (val) {
          formData.append('post_images[]', val.image_id);
        });
      } catch (e) {}
      formData.append('property_group_items', JSON.stringify(this.property_group_items));
      formData.append('property_id', this.selected_property || 0);
      try { formData.append('dk_specifications', JSON.stringify(product.specifications || [])); } catch (e) {}
      const dkr = product.rating || {};
      formData.append('dk_id', String(dk_id));
      formData.append('source_url', 'https://www.digikala.com/product/dkp-' + dk_id + '/');
      if (dkr.rate != null) formData.append('dk_rating', dkr.rate > 5 ? Math.round(dkr.rate / 20 * 100) / 100 : dkr.rate);
      if (dkr.count != null) formData.append('dk_rating_count', dkr.count);
      formData.append('product_type', this.product_type);
      formData.append('cat_list', this.value_category);
      formData.append('tags', this.value_tags);
      formData.append('brand_id', this.value_brand);
      formData.append('name', product.title_fa);
      formData.append('url', '');
      formData.append('code', String(dk_id));
      formData.append('text', JSON.stringify(text));
      formData.append('full_text', JSON.stringify(full_text));
      formData.append('meta_desc', seo.description || '');
      formData.append('meta_title', seo.title || product.title_fa);
      formData.append('keyword', this.keyword);
      formData.append('price', price);
      formData.append('product_stock', this.product_stock);
      formData.append('order_point', this.order_point);
      formData.append('product_off_price', typeof dkp !== 'undefined' ? dkp.off : '');
      formData.append('product_off_price_date', '');
      formData.append('selected_currency', this.selected_currency);
      return formData;
    },
    async dk_bulk_start() {
      if (!this.dk_bulk_url) { this.dk_bulk_add_log('لینک را وارد کنید', false); return; }
      const max = Math.max(1, parseInt(this.dk_bulk_max) || 1);
      const delay = Math.max(0, parseFloat(this.dk_bulk_delay) || 0) * 1000;
      this.dk_bulk_running = true;
      this.dk_bulk_stop = false;
      this.dk_bulk_log = [];
      this.dk_bulk_done = 0;
      let ok_count = 0;
      try {
        this.dk_bulk_add_log('در حال خواندن لیست محصولات از دیجی‌کالا...');
        const ids = await this.dk_bulk_fetch_ids(this.dk_bulk_url, max);
        this.dk_bulk_total = ids.length;
        this.dk_bulk_add_log(ids.length + ' محصول پیدا شد');
        for (let i = 0; i < ids.length; i++) {
          if (this.dk_bulk_stop) { this.dk_bulk_add_log('متوقف شد', false); break; }
          const item = ids[i];
          try {
            const fd = new FormData();
            fd.append('url', 'https://www.digikala.com/product/dkp-' + item.id + '/');
            fd.append('download_image', this.dk_bulk_download_image);
            const imp = await axios.post('/api/admin/product/import_digikala', fd, {});
            const contents = imp.data;
            if (!contents || !contents.data || !contents.data.product || contents.data.product.is_inactive) {
              throw new Error('محصول در دیجی‌کالا قابل خواندن نیست');
            }
            const res = await axios.post('/api/admin/product/insert_product', this.dk_bulk_build_form(contents, item.id), {});
            if (res.data && res.data.error == 0) {
              ok_count++;
              this.dk_bulk_add_log('✓ ' + item.title + ' (شناسه ' + res.data.id + ')', true);
            } else {
              this.dk_bulk_add_log('✗ ' + item.title + ': ' + ((res.data && (res.data.msg || res.data.message)) || 'خطا'), false);
            }
          } catch (e) {
            this.dk_bulk_add_log('✗ ' + item.title + ': ' + (e && e.message ? e.message : e), false);
          }
          this.dk_bulk_done = i + 1;
          if (i < ids.length - 1 && delay) await this.dk_bulk_sleep(delay);
        }
        this.dk_bulk_add_log('پایان: ' + ok_count + ' محصول منتشر شد', true);
      } catch (e) {
        this.dk_bulk_add_log('خطا در خواندن لینک: ' + (e && e.message ? e.message : e), false);
      }
      this.dk_bulk_running = false;
    },
    go_to_product() {
      window.open(localStorage.getItem("site_url")+"/product/"+this.favorite_url)
    },
    copy_product_link() {
      var textArea = document.createElement("textarea");
      textArea.value = localStorage.getItem("site_url")+"/product/"+this.favorite_url;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();


        // Select the text field
      textArea.select();
      textArea.setSelectionRange(0, 99999); // For mobile devices
        // Copy the text inside the text field
        navigator.clipboard.writeText(textArea.value);
      this.$toast.open({
        message: "کپی شد!!!",
        type: 'success',
        // all of other options may go here
      });
      document.body.removeChild(textArea);

    },
    get_digikala_data() {
      var self = this;
      // console.log("route id "+this.$route.params.cat_id);
      var formData = new FormData();
      formData.append("url", this.digikala_link)
      formData.append("download_image", this.digikala_modal_download_image)
      let url = '/api/admin/product/import_digikala'
      if (this.digikala_modal_selected_type == 2) {
        url = '/api/admin/product/import_wordpress'
      }
      axios.post(url, formData, {show_pros: self.dk_bulk_mode ? false : null}).then(function (response) {
        var contents = response.data;
        if (contents && contents.error == 1) {
          self.dk_import_error = contents.msg || 'خطا در دریافت اطلاعات';
          if (!self.dk_bulk_mode) self.$toast.open({message: self.dk_import_error, type: 'error'});
          return;
        }
        if (contents && contents.import_warnings && contents.import_warnings.length && !self.dk_bulk_mode) {
          self.$toast.open({message: 'برخی تصاویر دریافت نشد: ' + contents.import_warnings.join(' | '), type: 'warning'});
        }
        self.show_gallery = false
        self.loaded_page = false
        if(self.digikala_modal_selected_type==1){
          self.dk_specs = contents.data.product.specifications || null
          try {
            const dkp = contents.data.product, dkr = dkp.rating || {};
            self.dk_meta = {dk_id: dkp.id || '', source_url: self.digikala_link || '', dk_rating: dkr.rate != null ? (dkr.rate > 5 ? Math.round(dkr.rate / 20 * 100) / 100 : dkr.rate) : '', dk_rating_count: dkr.count != null ? dkr.count : ''};
          } catch (e) { self.dk_meta = null }
          self.title = contents.data.product.title_fa
          self.seo_title = contents.data.seo.title
          self.content_json_full = {time: 1708248359501,
            blocks: [{
              id: "DSM8JadA6h",
              type: "paragraph",
              data: {text: contents.data.product.expert_reviews.description, alignment: "right"}
            }],
            version: "2.28.2"
          }
          var json_specifications = contents.data.product.specifications[0].attributes
          var json_table = []
          json_specifications.forEach(function (val){
            json_table.push([val.title,val.values[0]])
          })
          // console.log("json", json_table)
          // specs go to dk_specifications/properties only, never into the short description
          self.content_json = {time: Date.now(), blocks: [], version: '2.28.2'}
          self.seo_summary = contents.data.seo.description
          self.product_price = dkPrice(contents.data.product).price; self.product_off_price = dkPrice(contents.data.product).off
          setTimeout(function () {
            self.show_gallery = true

          }, 1000)


          try{
            setTimeout(function () {
              self.loaded_page = true
              contents.data.product.images.list.forEach(function (val) {
                self.gallery.push(val.image_id)
              })
            }, 700)
          }catch (e) {

          }
        }
        if(self.digikala_modal_selected_type==2){
          var txt = document.createElement("textarea");
          txt.innerHTML = contents.name;
          self.title = txt.value
          self.seo_title = txt.value

          txt.innerHTML = contents.description;
          self.content_json_full = {time: 1708248359501,
            blocks: [{
              id: "DSM8JadA6h",
              type: "paragraph",
              data: {text: txt.value, alignment: "right"}
            }],
            version: "2.28.2"
          }
          self.seo_summary = txt.value.replace(/<[^>]*>?/gm, '');


          txt.innerHTML = contents.short_description;
          self.content_json = {time: 1708248359501,
            blocks: [{
              id: "DSM8JadA6h",
              type: "paragraph",
              data: {text: txt.value, alignment: "right"}
            }],
            version: "2.28.2"
          }
          setTimeout(function () {
            self.show_gallery = true

          }, 1000)
try{
  setTimeout(function () {
    self.loaded_page = true
    contents.images.forEach(function (val) {
      self.gallery.push(val.image_id)
    })
  }, 700)
}catch (e) {

}

        }




      })
          .catch(function (error) {
            self.dk_import_error = (error && error.response && error.response.data && error.response.data.msg) || 'خطا در ارتباط با سرور';
            console.log(error);
          });

    },

    load_tags({action, searchQuery, callback}) {

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          var formData = new FormData();
          formData.append('search', searchQuery);
          axios.post('/api/admin/product/search_product_tags', formData, {show_pros:false}).then(function (response) {
            options = response.data;
            callback(null, options);
          })
              .catch(function (error) {
                console.log(error);
              });

        })
      }
    },

    editImage(formData, index, fileList) {
      console.log('edit data', formData, index, fileList)
    },

    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_categories_with_children', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.options_category = content_cats.orders;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_brands() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_brands', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.options_brand = content_cats.orders;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_currencies() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/get_currencies', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.currency_items = self.sort_array([], content_cats.data, "id", "title");
        self.selected_currency = content_cats.default_unit;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_languages() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/get_languages', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.language_items = content_cats.data;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_properties() {
      var self = this;
      var formData = new FormData();

      axios.post('/api/admin/product/get_properties', formData, {}).then(function (response) {

        var content_cats = response.data;

        self.property_items = [];
        var obj = {label: "الگو را انتخاب کنید", value: 0}
        self.property_items.push(obj);
        content_cats.tags.forEach((val) => {
          var obj = {label: val.title, value: val.id}
          self.property_items.push(obj);
        });


        if (self.$route.params.product_id != null) {
          self.status_form = self.$route.params.product_id;
          self.get_post_info();
        } else if (self.$route.params.clone_product_id != null) {
          self.status_form = self.$route.params.clone_product_id;
          self.get_post_info();
        } else {
          self.loaded_page = true
        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_property_groups() {
      var self = this;
      var formData = new FormData();
      formData.append('property_id', self.selected_property)
      axios.post('/api/admin/product/get_property_groups_with_items', formData, {}).then(function (response) {

        var content_cats = response.data;

        if (content_cats.error == 0) {
          self.property_group_items = content_cats.tags;

          self.property_group_items.forEach((val) => {
            val.items_lang = []

            val.items.forEach((val_items) => {
              val_items.lang_values = []
              self.language_items.forEach(function (lng) {
                val_items.lang_values.push({value: '', lng: lng})
              })
            });
          });
          self.property_group_items.forEach((val) => {

            val.items.forEach((val_items) => {
              val_items.lang_values.forEach(function (lang_item) {

                self.product_property_values.forEach((val_product) => {
                  if (
                      val_product.property_key_id == val_items.id &&
                      val_product.lng == lang_item.lng.id
                  ) {
                    lang_item.value = val_product.title
                  }
                });

              })

            });
          });
        } else {
          self.property_group_items = [];

        }
      })
          .catch(function (error) {

            self.property_group_items = [];

            console.log(error);
          });

    },

    get_post_info() {
      var self = this;
      var formData = new FormData();
      formData.append("product_id", self.status_form)
      axios.post('/api/admin/product/get_product_info', formData, {}).then(function (response) {
        var post_data = response.data;
        self.value_category=[]
        post_data.post.categories.forEach((val) => {
          self.value_category.push(val.category_id);
        });
        self.value_tags = []
        post_data.post.tags.forEach((val) => {
          self.value_tags.push(val.tag.title.title);
        });

        self.product_property_values = post_data.post.properties;
        self.selected_property = post_data.property_id;

        self.code = post_data.post.code;
        self.product_type = post_data.post.type;
        self.favorite_url = post_data.post.title.slug;

        self.title = post_data.post.title.title;
        self.content_json = post_data.post.title.short_description;
        self.content_json_full = post_data.post.title.description;
        self.seo_summary = post_data.post.title.meta_description;
        self.seo_title = post_data.post.title.seo_title;
        self.keyword = post_data.post.title.keyword;
        if (post_data.post.brand) {
          self.value_brand = post_data.post.brand.brand_id;
        }
        if (post_data.post.price_no != null) {
          self.product_price = post_data.post.price_no.price;
          self.product_stock = post_data.post.price_no.stock;
          self.product_off_price = post_data.post.price_no.off_price;
          self.order_point = post_data.post.price_no.order_point;
          self.selected_currency = post_data.post.price_no.currency_id;
          self.product_off_price_date = post_data.post.price_no.off_expire;
        }
        self.gallery=[]
        post_data.post.gallery.forEach((val2) => {
          self.gallery.push(val2.image_id);
        });
        self.loaded_page = true
        if (self.$route.params.clone_product_id != null) {
          self.status_form = 0
        }
      }).catch(function (error) {
        console.log(error);
      });


    },


    login() {

      let self = this;
      // category is required (the API also rejects products without a valid category)
      if (!this.value_category || !this.value_category.length) {
        this.category_touched = true;
        const msg = 'انتخاب دسته‌بندی محصول الزامی است';
        if (this.dk_bulk_mode) { this.dk_last_save = {error: 1, msg: msg}; return Promise.resolve(); }
        this.$toast.open({message: msg, type: 'error'});
        return Promise.resolve();
      }
      const formData = new FormData()
      let url;
      if (self.status_form == 0) {
        url = "/api/admin/product/insert_product";
      } else {
        url = "/api/admin/product/update_product";
        formData.append('product_id', this.status_form)

      }
      for (var i = 0; i < this.gallery.length; i++) {

          formData.append('post_images[]', this.gallery[i])

      }
      formData.append('property_group_items', JSON.stringify(this.property_group_items));
      formData.append('property_id', this.selected_property || 0);
      // Digikala specs: the API maps them into the category's property template when no values were typed
      if (this.dk_specs && self.status_form == 0) formData.append('dk_specifications', JSON.stringify(this.dk_specs));
      if (this.dk_meta && self.status_form == 0) {
        Object.keys(this.dk_meta).forEach((k) => { if (this.dk_meta[k] !== '' && this.dk_meta[k] != null) formData.append(k, this.dk_meta[k]); });
      }
      formData.append('product_type', this.product_type);
      formData.append('cat_list', this.value_category);
      formData.append('tags', this.value_tags);
      formData.append('brand_id', this.value_brand);
      formData.append('name', this.title);
      formData.append('url', this.favorite_url);
      formData.append('code', this.code);
      formData.append('text', JSON.stringify(this.content_json));
      formData.append('full_text', JSON.stringify(this.content_json_full));
      formData.append('meta_desc', this.seo_summary);
      formData.append('meta_title', this.seo_title);
      formData.append('keyword', this.keyword);
      formData.append('price', this.product_price);
      formData.append('product_stock', this.product_stock);
      formData.append('order_point', this.order_point);
      formData.append('product_off_price', this.product_off_price);
      formData.append('product_off_price_date', this.product_off_price_date);
      formData.append('selected_currency', this.selected_currency);

      return axios.post(url, formData, {show_pros: self.dk_bulk_mode ? false : null}).then(async (res) => {
        self.dk_last_save = res.data;
        if (!self.dk_bulk_mode && res.data && res.data.error == 0 && self.$refs.seo) await self.$refs.seo.save(self.status_form == 0 ? res.data.id : self.status_form);
        if (!self.dk_bulk_mode) self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.name = '';
          self.mobile = '';
          self.email = '';
          self.description = '';
          self.password = '';
          self.product_price = '';
          self.product_stock = '';
          self.product_off_price = '';
          self.order_point = 0;
          self.product_off_price_date = '';
          self.selected_property = '0';
          if(res.data.error==0 && !self.dk_bulk_mode){
            self.$router.push({path:"/dashboard/products/edit/" + res.data.id})
          }
        }else{
          self.get_post_info()
        }

      }).catch(function (error) {

        console.log(error);
      });

    }
  }
}


</script>
<style>
.ap-seobox { margin-bottom: 16px; }

.dk-run__head { display: flex; justify-content: space-between; align-items: center; gap: 8px; flex-wrap: wrap; }
.dk-run__ok { color: #16a34a; font-weight: 800; font-size: 16px; }
.dk-run__err { color: #e85364; }

/* ---------- Add product page (new layout) ---------- */
.ap-page { padding-bottom: 88px; margin-left: -15px; margin-right: -15px; }
.ap-page > .ap-card { margin-left: 0; margin-right: 0; }
.ap-grid { margin-left: -8px; margin-right: -8px; }
.ap-grid > [class*="col"] { padding-left: 8px; padding-right: 8px; }
.ap-page .ap-card { margin-bottom: 16px; }
.ap-card {
  background: var(--panel-surface, #fff);
  border: 1px solid var(--panel-border, rgba(128,148,174,.14));
  border-radius: 16px;
  box-shadow: none;
  margin-bottom: 20px;
}
.ap-card__head {
  display: flex; flex-direction: column; gap: 14px;
  padding: 16px;
}
.ap-card__body { padding: 16px; }
.ap-card__title-wrap { display: flex; align-items: center; gap: 12px; min-width: 0; }
.ap-card__icon {
  width: 40px; height: 40px; border-radius: 12px; flex-shrink: 0;
  background: var(--panel-accent-soft, #f4f4f5); color: var(--panel-accent, #111111);
  display: inline-flex; align-items: center; justify-content: center;
}
.ap-card__icon .c-icon { width: 20px; height: 20px; }
.ap-card__icon--warn { background: rgba(217,119,6,.1); color: #d97706; }
.ap-card__title { margin: 0; font-size: 16px; font-weight: 800; color: var(--panel-text, #364a63); }
.ap-card__title--lg { font-size: 19px; }
.ap-card__sub { margin: 4px 0 0; font-size: 12px; color: var(--panel-muted, #8094ae); }
.ap-section__head {
  padding: 14px 16px; border-bottom: 1px solid var(--panel-border, rgba(128,148,174,.14));
}
.ap-section__head h3 { margin: 0; font-size: 14px; font-weight: 800; color: var(--panel-text, #364a63); }
.ap-toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
.ap-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 6px;
  min-height: 38px; padding: 8px 14px; border-radius: 10px; border: 1px solid transparent;
  font-family: inherit; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap;
  transition: background .15s ease, color .15s ease, border-color .15s ease;
}
.ap-btn .c-icon { width: 16px; height: 16px; }
.ap-btn--primary { background: #111111; color: #fff; border-color: #111111; }
.ap-btn--primary:hover { background: #111111; }
.ap-btn--primary .c-icon, .ap-btn--primary span { color: #fff; }
.ap-btn--ghost {
  background: var(--panel-surface-2, #f7f8fb); color: var(--panel-text, #364a63);
  border-color: var(--panel-border, rgba(128,148,174,.2));
}
.ap-btn--ghost:hover { background: var(--panel-accent-soft, #f4f4f5); color: var(--panel-accent, #111111); border-color: rgba(17, 17, 17,.25); }
.ap-btn--danger { background: #e85364; color: #fff; }
.ap-icon-btn {
  width: 38px; height: 38px; border-radius: 10px; padding: 0; cursor: pointer;
  border: 1px solid var(--panel-border, rgba(128,148,174,.2)); background: var(--panel-surface, #fff);
  color: var(--panel-nav, #6e82a5); display: inline-flex; align-items: center; justify-content: center;
}
.ap-icon-btn:hover { background: var(--panel-accent-soft, #f4f4f5); color: var(--panel-accent, #111111); }
.ap-icon-btn .c-icon { width: 16px; height: 16px; }
.ap-muted { color: var(--panel-muted, #8094ae); font-size: 13px; }
.ap-field { margin-bottom: 16px; }
.ap-field-label { font-size: 13px; font-weight: 600; color: var(--panel-text, #364a63); margin-bottom: 6px; }
.ap-hint { font-size: 12px; color: var(--panel-muted, #8094ae); margin: 4px 0 12px; }
.ap-hint--warn { color: #d97706; }
.ap-editor {
  border: 1px solid var(--panel-border, rgba(128,148,174,.2)); border-radius: 12px;
  padding: 8px 12px; min-height: 120px; background: var(--panel-surface, #fff);
}
.ap-switch { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
.ap-switch label { margin: 0; }
.ap-props { margin-top: 8px; }
.ap-props__values { display: flex; flex-wrap: wrap; gap: 6px; }
.ap-props__values .form-group { min-width: 140px; flex: 1; }
.ap-page .vue-treeselect__control { border-radius: 10px; min-height: 38px; }
.ap-page .form-control { border-radius: 10px; }
.ap-savebar {
  position: sticky; bottom: 12px; z-index: 20;
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  padding: 10px 16px; border-radius: 14px;
  background: var(--panel-surface, #fff); border: 1px solid var(--panel-border, rgba(128,148,174,.2));
  box-shadow: none;
}
.ap-savebar .ap-muted { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ap-run__list { display: flex; flex-direction: column; }
.ap-run__row {
  display: flex; align-items: center; gap: 10px; padding: 10px 8px;
  border-top: 1px solid var(--panel-border, rgba(128,148,174,.12)); font-size: 13px;
}
.ap-run__row:first-child { border-top: 0; }
.ap-run__row.is-working { background: rgba(17, 17, 17,.06); border-radius: 10px; }
.ap-run__num { width: 24px; color: var(--panel-muted, #8094ae); }
.ap-run__state { width: 28px; text-align: center; }
.ap-run__title { flex: 1; min-width: 0; }
.ap-run__link { font-size: 12px; max-width: 45%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ap-run__ok { color: #16a34a; font-weight: 800; font-size: 16px; }
.ap-run__err { color: #e85364; }
.ap-run__skip { color: #d97706; font-weight: 800; font-size: 16px; }
.ap-run__row.is-skip { opacity: .75; }
.ap-run__wait { color: #c0c8d4; font-size: 16px; }
@media (min-width: 768px) {
  .ap-card__head { flex-direction: row; align-items: center; justify-content: space-between; padding: 18px 20px; }
  .ap-card__body { padding: 18px 20px; }
  .ap-section__head { padding: 14px 20px; }
}
@media (min-width: 992px) {
  .ap-side { position: sticky; top: 16px; }
}
</style>
